<template>
    <div class="warp">
      <div class="user-row">
        <div class="user-inner">
          <div class="avatar-col">
            <div id="header_div">
              <div id="header_type" ref="header_type"></div>
              <div id="eye_type" ref="eye_type"></div>
              <div id="mouth_type" ref="mouth_type"></div>
              <div id="hair_type" ref="hair_type"></div>
            </div>
          </div>
          <div class="compass-col">
            <compass class="desktop-compass"></compass>
          </div>
        </div>
      </div>

      <!-- 功能区：去掉分组标题压缩高度，8 个按钮一组排布 -->
      <div class="func-group">
        <a @click="showCurUserDetail();" class="func-btn">详细资料</a>
        <a @click="showMasteryPanel();" class="func-btn">熟练度</a>
        <a @click="openpocket" class="func-btn">打开背包</a>
        <a @click="taskList()" class="func-btn">任务列表</a>
        <a @click="openLetterBox" class="func-btn">信箱</a>
        <a @click="openFriendsBox" class="func-btn">好友</a>
        <a v-if="null!=fantasyUserBO.homePoint" @click="toHome();" class="func-btn">回家</a>
        <a @click="save();" class="func-btn">存盘</a>
        <a @click="savequit" class="func-btn danger">存盘退出</a>
      </div>
      
      <!-- 个人资料 -->
      <div class="curUserDetail" v-if="false != curUserDetailDiv">
        <curUserDetail 
          v-on:cur_user_detail_dialog_close="cur_user_detail_dialog_close"
          v-bind:curUserDetailTableVisible="curUserDetailTableVisible"
          v-bind:fantasyUserBO="fantasyUserBO" 
          v-bind:fantasyUserDetail="fantasyUserDetail"
          v-bind:fantasyUserProperty="fantasyUserProperty"></curUserDetail>
      </div>
      <!-- 背包窗口 -->
      <pocket
        v-on:ai_dialog_close="ai_dialog_close"
        v-bind:pocketItems="pocketItems"
        v-bind:loading="pocketLoading"
        v-bind:dialogTableVisible="dialogTableVisible"></pocket>
        
        <!-- 任务列表（公共弹窗组件，右下角快捷条共用同一实现） -->
        <taskListDialog ref="taskListDialog"></taskListDialog>
      <letterPanel ref="letterPanel" v-bind:letterPanelVisible="letterPanelVisible" v-on:letter_panel_dialog_close="letter_panel_dialog_close"></letterPanel>
      <friendsPanel v-bind:friendsPanelVisible="friendsPanelVisible" v-on:friends_panel_dialog_close="friends_panel_dialog_close" v-on:write-to="writeToFriend"></friendsPanel>
      <!-- 熟练度总览 延迟加载 -->
    <div v-if="masteryPanelShow">
      <masteryPanel
        v-on:mastery_panel_close="mastery_panel_close"
        v-bind:masteryPanelVisible="masteryPanelVisible"></masteryPanel>
    </div>
  </div>
</template>
<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import {mapState} from 'vuex'
import compass from './compass'
import pocket from './pocket'
import curUserDetail from '../home/curUserDetail';
import letterPanel from '../common/letterPanel';
import friendsPanel from '../common/friendsPanel';
import masteryPanel from '../common/masteryPanel';
import taskListDialog from '../common/taskListDialog';
export default {
  components:{
    compass,
    pocket,
    curUserDetail,
    letterPanel,
    friendsPanel,
    masteryPanel,
    taskListDialog
  },
  data() {
    return {
      masteryPanelShow: false,
      masteryPanelVisible: false,
      cityMap: {
        id: "",
        placename: "",
        cityname: "",
        placedesc: "",
        north: 0, northeast: 0, east: 0, southeast: 0,
        south: 0, southwest: 0, west: 0, northwest: 0,
      },
      dialogTableVisible: false,
      pocketItems: [],
      pocketLoading: false,
      itemCount: 0,
      curUserDetailTableVisible: false,
      fromId: null,
      targetId: null,
      curUserDetailDiv: false,
      letterPanelVisible: false,
      friendsPanelVisible: false
    };
  },
  computed: {
    ...mapState('user', ['fantasyUserBO', 'fantasyUserDetail', 'fantasyUserProperty', 'userHeader'])
  },
  watch: {
    // 玩家属性收拢：首次获得用户信息后拉取详情/头像
    'fantasyUserBO.id': function(newId) {
      if (newId != null) {
        this.$store.dispatch('user/fetchUserDetail');
        this.$store.dispatch('user/fetchUserHeader', newId);
      }
    },
    // 头像部件变化时刷新 DOM（原 refreshFantasyUserHeader 逻辑）
    userHeader: function(h) {
      h = h || {};
      if (!this.$refs.header_type) return;
      try {
        if (h.mouthUrl) this.$refs.mouth_type.style.backgroundImage = "url(" + this.ossPath + h.mouthUrl + ")";
        if (h.faceUrl) this.$refs.header_type.style.backgroundImage = "url(" + this.ossPath + h.faceUrl + ")";
        if (h.eyeUrl) this.$refs.eye_type.style.backgroundImage = "url(" + this.ossPath + h.eyeUrl + ")";
        if (h.hairUrl) this.$refs.hair_type.style.backgroundImage = "url(" + this.ossPath + h.hairUrl + ")";
      } catch (e) {}
    }
  },
  mounted: function () {
    this.$root.eventHub.$on('cityMap',this.changeCityMap);
    // 页面刷新后 store 已初始化时补齐详情/头像
    if (this.fantasyUserBO.id != null) {
      this.$store.dispatch('user/fetchUserDetail');
      this.$store.dispatch('user/fetchUserHeader', this.fantasyUserBO.id);
    }
  },
  beforeDestroy: function() {
    this.$root.eventHub.$off('cityMap',this.changeCityMap);
  },
  methods: {
    cur_user_detail_dialog_close(){
      this.curUserDetailDiv = false;
      this.curUserDetailTableVisible = false;
    },
    showMasteryPanel() {
      this.masteryPanelShow = true;
      this.masteryPanelVisible = true;
    },
    mastery_panel_close() {
      this.masteryPanelVisible = false;
      this.masteryPanelShow = false;
    },
    showCurUserDetail() {
      this.curUserDetailDiv = true;
      this.curUserDetailTableVisible = true;
      this.$store.dispatch('user/fetchUserDetail');
    },
    ai_dialog_close(){
      this.dialogTableVisible = false;
    },
    openLetterBox(){
      this.letterPanelVisible = true;
    },
    letter_panel_dialog_close(){
      this.letterPanelVisible = false;
    },
    openFriendsBox(){
      this.friendsPanelVisible = true;
    },
    friends_panel_dialog_close(){
      this.friendsPanelVisible = false;
    },
    writeToFriend(friend){
      // 好友面板直达写信：预选收件人后再打开信箱
      this.$refs.letterPanel.writeTo(friend);
      this.friendsPanelVisible = false;
      this.letterPanelVisible = true;
    },
    openpocket: function(){
      this.dialogTableVisible = true;
      this.pocketItems = [];
      // 请求期间显示 loading，避免「空白弹窗停顿」被感知成卡顿
      this.pocketLoading = true;
      getRequest('/item/cabinet/openPocket', {}).then(resp=> {
        this.pocketLoading = false;
        if (resp.status == 200) {
          var respData = resp.data;
          if (200 == respData.status) {
            this.pocketItems = respData.data.pocketItems;
            this.itemCount = this.pocketItems.length;
          } else { Message.error(respData.message); }
        } else { Message.error('用户非法⊙﹏⊙∥!'); }
      }, resp=> { this.pocketLoading = false; Message.error('用户非法⊙﹏⊙∥!'); });
    },
    changeCityMap(cityMap) { this.cityMap = cityMap; },
    taskList: function() {
      this.$refs.taskListDialog.open();
    },
    toHome: function() {
      var _this = this;
      this.$confirm('请注意，传送回家需要消耗一定的体力值。', '警告', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(function () {
        postRequest('/map/move/teleport', { from: _this.cityMap.id, target: 'home' }).then(resp=> {
          if (resp.status == 200) {
            var respData = resp.data;
            if (200 == respData.status) { _this.$router.replace({path: '/main/home.html'}); }
            else { Message.error(respData.message); }
          } else { Message.error('用户非法⊙﹏⊙∥!'); }
        }, resp=> { Message.error('用户非法⊙﹏⊙∥!'); }).catch(err => { console.log(err); })
      });
    },
    save: function() {
      postRequest('/user/user/saveStatus', {}).then(resp=> {
        if (resp.status == 200) {
          var respData = resp.data;
          if (200 == respData.status) { Message.success(respData.message); }
          else { Message.error(respData.message); }
        } else { Message.error('用户非法⊙﹏⊙∥!1'); }
      }, resp=> { Message.error('用户非法⊙﹏⊙∥!2'); });
    },
    savequit: function(){
      var _this = this;
      this.$confirm('您确定要存盘退出吗?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(function () {
        // 先存盘（累计本次在线时长），完成后再登出；存盘失败也照常退出但给出提示
        postRequest('/user/user/saveStatus', {}).then(function () {
          postRequest("/auth/login/logout", { mapId: _this.cityMap.id });
          _this.$router.replace({path: '/'});
        }, function () {
          Message.error('存盘失败，本次在线时长可能未计入');
          postRequest("/auth/login/logout", { mapId: _this.cityMap.id });
          _this.$router.replace({path: '/'});
        });
      });
    },
  }
}
</script>

<style scoped>
a { cursor: pointer; }

.warp {
  padding: 6px 5px;
  background: linear-gradient(180deg, #3d3250 0%, #2d2340 100%);
  border: 1px solid #5a4f6c;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  margin: 0;
  text-align: center;
  color: #f0e6d2;
}

/* ========== 用户行 ========== */
.user-row {
  display: flex;
  justify-content: center;
  margin-bottom: 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid #5a4f6c;
}

.user-inner {
  display: flex;
  align-items: center;
}

.avatar-col {
  flex-shrink: 0;
  margin-right: 8px;
  padding: 3px;
  background: #e8dfcf;
  border: 2px solid #8b7355;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.compass-col {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* ========== 功能按钮 ========== */
.func-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5px;
  margin-bottom: 6px;
}
.func-group:last-child {
  margin-bottom: 0;
}

.func-btn {
  display: block;
  padding: 3px 3px;
  font-size: 12px;
  color: #f0e6d2;
  text-decoration: none;
  text-align: center;
  background: linear-gradient(180deg, #4a3f5c 0%, #3d3250 100%);
  border: 1px solid #5a4f6c;
  border-radius: 5px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.22);
  transition: all 0.15s;
  line-height: 1.25;
  letter-spacing: 0.5px;
}
.func-btn:hover {
  color: #fff;
  background: linear-gradient(180deg, #5a4f6c 0%, #4a3f5c 100%);
  border-color: #d4a574;
  text-decoration: none;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.35);
}
.func-btn.danger {
  color: #ffd4d4;
  background: linear-gradient(180deg, #6b3b3b 0%, #522828 100%);
  border-color: #8b4a4a;
}
.func-btn.danger:hover {
  color: #fff;
  background: linear-gradient(180deg, #8b4a4a 0%, #6b3b3b 100%);
  border-color: #e04242;
}

/* ========== 头像 ========== */
#header_div {
  width: 64px; height: 80px;
  background-size: 64px 80px;
  position: relative;
}
#header_div #hair_type, #header_div #eye_type,
#header_div #mouth_type, #header_div #header_type {
  width: 64px; height: 80px;
  background-size: 64px 80px;
  background-repeat: no-repeat;
  position: absolute;
}

/* 移动端隐藏罗盘 */
@media (max-width: 768px) {
  .desktop-compass { display: none !important; }
}

/* PC 端：仅略微增大字号，保持无滚动条 */
@media (min-width: 769px) {
  .func-btn {
    font-size: 13px;
  }
}
</style>
